<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block">
      <div class="top-title">申请补贴</div>
      <div class="title">申请人信息</div>
      <el-form
        ref="form"
        :rules="rules"
        :model="formData"
        label-width="150px"
        label-position="left"
        size="mini"
      >
        <el-form-item label="申请人姓名" prop="applyRealName">
          <el-input v-model="formData.applyRealName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="申请人身份证号" prop="applyIdCardNumber">
          <el-input v-model="formData.applyIdCardNumber" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="申请人联系电话" prop="applyPhoneNumber">
          <el-input v-model="formData.applyPhoneNumber" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="申请人家庭住址" prop="applyAddress">
          <el-input v-model="formData.applyAddress" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="银行账号" prop="applyBankAccountNumber" class="bank">
          <el-select v-model="formData.applyBankAccountNumber" @change="handleBank">
            <el-option
              v-for="(item, index) in bankList"
              :key="index"
              :label="item.bankCard"
              :value="item.bankCard"
            ></el-option>
          </el-select>
          <el-input
            v-model="formData.otherBankCard"
            placeholder="选择其他时，请输入"
            :disabled="formData.applyBankAccountNumber!='其他'"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户银行" prop="applyBankName">
          <el-input
            v-model="formData.applyBankName"
            placeholder="请输入"
            :disabled="formData.applyBankAccountNumber!='其他'"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="validCode">
          <el-input v-model="formData.validCode" placeholder="请输入"></el-input>
          <span class="code" @click="getCountdown">{{countdown}}</span>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button @click="$router.go(-1)">上一步</el-button>
        <el-button class="sumbit" @click="saveSumbit()">提交</el-button>
      </div>
    </div>
    <!-- 补贴金额 -->
    <el-dialog class="money" width="500px" top="30vh" title="温馨提示" :visible.sync="diaShow">
      <div class="info">
        {{this.formData.applyRealName}}，您有
        <span class="blueC">{{total}}元</span> 补贴，完善信息后可以申请该项补贴
      </div>
      <el-table :data="tableData" border>
        <el-table-column header-align="center" align="center" label="补贴项目" prop="subsidyProject"></el-table-column>
        <el-table-column header-align="center" align="center" label="补贴金额（元）" prop="subsidyAmount"></el-table-column>
      </el-table>
      <div class="btn dia-btn">
        <el-button @click="dialogSumbitL">取消</el-button>
        <el-button class="sumbit" @click="dialogSumbitR">继续申请</el-button>
      </div>
    </el-dialog>
    <!-- 申请人 -->
    <el-dialog
      class="apply-subsidy"
      width="380px"
      top="30vh"
      title="温馨提示"
      :visible.sync="show"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="apply-btn">
        <div @click="personApply()">本人申请</div>
        <div class="others" @click="proxyApply()">代他人申请</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 22321313123123123 中国建设银行
import Dialog from "@/components/Dialog";
import publicFun from "@/utils/publicFunction";
import HeaderImg from "@/components/HeaderImg";
import { sessionStore } from "@/utils/data-management";
import { tableFilter } from "@/views/property-exchange-center/info-collection/tableFilter";
export default {
  components: {
    Dialog,
    HeaderImg
  },
  data() {
    return {
      headerList: [
        { name: "产权流转交易中心", path: "/Home" },
        { name: "补贴申请" },
        { name: "申请人信息" }
      ],
      bankList: [],
      formData: {
        applyRealName: "",
        applyAddress: "",
        applyPhoneNumber: "",
        applyIdCardNumber: "",
        applyBankAccountNumber: "",
        applyBankName: "",
        otherBankCard: "",
        validCode: ""
      },
      rules: {
        applyRealName: [
          { required: true, message: "请输入姓名", trigger: "blur" }
        ],
        applyIdCardNumber: [
          { required: true, message: "请输入身份证号", trigger: "blur" }
        ],
        applyPhoneNumber: [
          { required: true, message: "请输入联系电话", trigger: "blur" }
        ],
        applyAddress: [
          { required: true, message: "请输入家庭住址", trigger: "blur" }
        ],
        applyBankAccountNumber: [
          { required: true, message: "请输入银行卡", trigger: "blur" }
        ],
        applyBankName: [
          { required: true, message: "请输入开户银行", trigger: "blur" }
        ],
        validCode: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      },
      countdown: "获取短信验证码",
      diaShow: false,
      tableData: [],
      show: false,
      total: 0
    };
  },
  computed: {
    status() {
      return this.$store.state.infoStatus;
    }
  },
  methods: {
    // 选择银行卡
    handleBank(val) {
      this.bankList.map(item => {
        if (val == "其他") {
          return (this.formData.applyBankName = "");
        }
        if (item.bankCard == val) {
          this.formData.otherBankCard = "";
          this.formData.applyBankName = item.bankName;
        }
      });
    },
    // 倒计时
    getCountdown() {
      if (!publicFun.isPhone(this.formData.applyPhoneNumber)) {
        return this.$message.error("请输入正确的手机号");
      }
      if (this.countdown != "获取短信验证码") return;
      let countdown = 60;
      this.$api.apply
        .subsidyCode({ phone: this.formData.applyPhoneNumber })
        .then(res => {
          if (res.code == 1000) {
            let timer = setInterval(() => {
              if (countdown == 0) {
                this.countdown = "获取短信验证码";
                clearInterval(timer);
              } else {
                this.countdown = `倒计时${countdown}秒`;
                countdown--;
              }
            }, 1000);
          }
          if (res.code == 1020) {
            countdown = res.data;
            let timer = setInterval(() => {
              if (countdown == 0) {
                this.countdown = "获取短信验证码";
                clearInterval(timer);
              } else {
                this.countdown = `倒计时${countdown}秒`;
                countdown--;
              }
            }, 1000);
          }
        });
    },
    saveSumbit() {
      this.$refs.form.validate(v => {
        if (v) {
          if (!publicFun.isIdCard(this.formData.applyIdCardNumber)) {
            return this.$message.error("请输入正确的身份证号");
          }
          if (!publicFun.isPhone(this.formData.applyPhoneNumber)) {
            return this.$message.error("请输入正确的手机号");
          }
          if (
            this.formData.applyBankAccountNumber == "其他" &&
            !this.formData.otherBankCard
          ) {
            return this.$message.error("请输入银行账号");
          }
          let data = {
            applyRealName: this.formData.applyRealName,
            applyIdCardNumber: this.formData.applyIdCardNumber
          };
          this.$api.apply.subsidySome(data).then(res => {
            if (res.code == 1000) {
              this.diaShow = true;
              this.total = 0;
              res.data.map(item => {
                this.total += item.subsidyAmount;
                item.subsidyAmount = item.subsidyAmount * 0.01;
              });
              this.tableData = res.data;
              this.total = this.total * 0.01;
            }
          });
        }
      });
    },
    dialogSumbitL() {
      this.diaShow = false;
    },
    dialogSumbitR() {
      this.diaShow = false;
      this.show = true;
    },
    // 本人申请
    personApply() {
      this.diaShow = false;
      let data = publicFun.lcDeepCopy(this.formData);
      if (data.applyBankAccountNumber == "其他") {
        data.applyBankAccountNumber = data.otherBankCard;
      }
      delete data.otherBankCard;
      data.areaId = this.$store.state.cityArea.areaConfigId
      this.$api.apply.subsidyAdd(data).then(res => {
        if (res.code == 1000) {
          this.$api.user
            .getFarmersInfo({
              phone: sessionStore.get("userInfo").phone
            })
            .then(res => {
              if (res.code == 1000) {
                // 是否填写完整
                tableFilter(res.data, true);
                if (this.status != 2 && this.status != 3) {
                  // 需补充信息
                  this.$goTo("infoCollection", { type: "1" });
                  return;
                }
                // 信息采集通过
                this.$api.apply.subsidySubmit({areaId: this.$store.state.cityArea.areaConfigId}).then(res => {
                  if (res.code == 1000) {
                    this.$message.success("申请补贴成功");
                    setTimeout(() => {
                      this.show = false;
                      this.$router.push("mySubsidy");
                    }, 500);
                  }
                });
              }
            });
        }
      });
    },
    // 他人申请
    proxyApply() {
      this.diaShow = false;
      let data = publicFun.lcDeepCopy(this.formData);
      if (data.applyBankAccountNumber == "其他") {
        data.applyBankAccountNumber = data.otherBankCard;
      }
      delete data.otherBankCard;
      sessionStore.set("subsidy", data);
      let info = {
        ...data,
        tableData: this.tableData
      };
      sessionStore.set("subsidyInfo", info);
      let num = "";
      if (this.$route.query.num == 2) {
        num = 2;
      }
      this.$goTo("applySubsidyOthers", { num: num });
    },
    init() {
      let data = sessionStore.get("userInfo");
      this.bankList = [{ bankName: data.bankName, bankCard: data.bankCard }];
      this.bankList.push({ bankName: "其他", bankCard: "其他" });
      if (this.$route.query.num == 2) {
        let info = sessionStore.get("subsidyAgain");
        this.formData = {
          applyRealName: info.applyRealName,
          applyAddress: info.applyAddress,
          applyPhoneNumber: info.applyPhoneNumber,
          applyIdCardNumber: info.applyIdCardNumber,
          applyBankAccountNumber: info.applyBankAccountNumber,
          applyBankName: info.applyBankName,
          otherBankCard: info.otherBankCard
        };
      }
    }
  },
  created() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.main-block {
  padding: 35px;
  .title {
    width: 900px;
    line-height: 54px;
    padding-left: 54px;
    margin: 95px auto 0;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #394259;
    background: #f8f9fb;
  }
  .el-form {
    width: 900px;
    padding-left: 50px;
    margin: 20px auto;
    /deep/ .el-form-item {
      .el-input {
        width: 300px;
        input {
          height: 30px;
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
          border: 1px solid rgba(240, 240, 240, 1);
          padding: 9px 10px;
        }
      }
      &.bank {
        .el-input {
          width: 180px;
          margin-right: 20px;
        }
      }
    }
    .code {
      display: inline-block;
      width: 111px;
      line-height: 27px;
      margin-left: 10px;
      cursor: pointer;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      text-align: center;
      color: #007bff;
      border: 1px solid #007bff;
      border-radius: 2px;
    }
  }
}
.money {
  /deep/ .el-dialog__body {
    padding: 35px 38px;
  }
  .info {
    font-family: PingFangSC-Medium;
    font-size: 18px;
    color: #394259;
    letter-spacing: 0.4px;
    margin-bottom: 23px;
    span {
      font-size: 22px;
    }
  }
  .dia-btn {
    margin: 23px 0 0;
    justify-content: center;
  }
}
.apply-subsidy {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #ebecef;
  }
  .apply-btn {
    display: flex;
    justify-content: center;
    margin: 10px 0;
    div {
      width: 140px;
      line-height: 80px;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #394259;
      text-align: center;
      border: 1px solid #f3f3f3;
      box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.06);
      border-radius: 2px;
      background: #ffffff;
      cursor: pointer;
    }
    .others {
      margin-left: 20px;
      color: #ff5038;
      border-color: #ff5038;
    }
  }
}
</style>